export default "__VITE_ASSET__DWIPwcVw__"